import script from "./Orderinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./Orderinfo.vue?vue&type=script&setup=true&lang=js"

import "./Orderinfo.vue?vue&type=style&index=0&id=d087a54a&lang=scss&scoped=true"

import exportComponent from "E:\\online_project\\app_pcw365\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d087a54a"]])

export default __exports__